<div class="tabs-container" [hidden]="showingDetail">
    <tabs (tabClicked)="onTabClicked()">
        <tab title="First">
            <ag-grid-angular class="data-grid " [rowData]="firstPendingFlows" [gridOptions]="firstReviewGridOptions" [attr.aria-label]="widgetTitle + ' - First'">
            </ag-grid-angular>
        </tab>

        <tab title="Final">
            <ag-grid-angular class="data-grid " [rowData]="finalPendingFlows" [gridOptions]="finalReviewGridOptions" [attr.aria-label]="widgetTitle + ' - Final'">
            </ag-grid-angular>
        </tab>

    </tabs>
</div>